import { render, staticRenderFns } from "./EquipoForm.vue?vue&type=template&id=1d47f2fa"
import script from "./EquipoForm.vue?vue&type=script&lang=js"
export * from "./EquipoForm.vue?vue&type=script&lang=js"
import style0 from "./EquipoForm.vue?vue&type=style&index=0&id=1d47f2fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports